export const CONTEXT = {
  pdp: 'PDP',
  myReviews: 'My Reviews',
  productAccordion: 'Product Accordion',
};
